import api from './api';

/** Columna ArticuloXListaPrecio.Descripcion en BD (30); no confundir con ListaPrecio.Descripcion (60) ni Stock.Descripcion (101). */
export const ARTICULO_X_LISTA_PRECIO_DESCRIPCION_MAX_LENGTH = 30;

export function normalizeArticuloXListaPrecioDescripcion(value: string | undefined | null): string {
    const t = (value ?? '').trim();
    if (t.length <= ARTICULO_X_LISTA_PRECIO_DESCRIPCION_MAX_LENGTH) return t;
    return t.slice(0, ARTICULO_X_LISTA_PRECIO_DESCRIPCION_MAX_LENGTH);
}

export interface ArticuloXListaPrecio {
    codigoLista: string;
    codigoArticulo: string;
    descripcion: string;
    codigoMoneda?: string;
    precioVta?: number;
    precioCosto?: number;
    propio: string;
    iva: string;
    descuento?: string;
    flete?: number;
    fleteFp: string;
    porcentaje?: number;
    codigoRamo: string;
    nombreRamo: string;
    codigoLinea: string;
    nombreLinea: string;
    codigoClase: string;
    nombreClase?: string;
    variacion?: number;
    variacionFp?: string;
    variacionBasadaEn?: string;
    variacionSigno?: string;
    usuario?: string;
    fechaActualizacion?: Date;
    horaActualizacion?: Date;
    minMarkUp?: number;
}

export interface ArticuloXListaPrecioSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    codigoLista?: string;
    codigoArticulo?: string;
    codigoRamo?: string;
    codigoLinea?: string;
    codigoClase?: string;
}

export interface ArticuloXListaPrecioPagedResult {
    items: ArticuloXListaPrecio[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

export type ModoPrecioImportacion = 'PRECIO' | 'PORCENTAJE';

export interface ArticuloXListaPrecioImportRow {
    codigoLista: string;
    codigoArticulo: string;
    modoPrecio: ModoPrecioImportacion;
    precioVenta?: number;
    porcentajeAjuste?: number;
    observaciones?: string;
    descripcion?: string;
}

const articuloXListaPrecioService = {
    getArticuloXListaPrecios: async (params: ArticuloXListaPrecioSearchParams): Promise<ArticuloXListaPrecioPagedResult> => {
        const response = await api.get<ArticuloXListaPrecioPagedResult>('/api/articuloxlistaprecios', { params });
        return response.data;
    },

    getArticuloXListaPrecio: async (codigoLista: string, codigoArticulo: string): Promise<ArticuloXListaPrecio> => {
        const response = await api.get<ArticuloXListaPrecio>(`/api/articuloxlistaprecios/${codigoLista}/${codigoArticulo}`);
        return response.data;
    },

    createArticuloXListaPrecio: async (articuloXListaPrecio: ArticuloXListaPrecio): Promise<ArticuloXListaPrecio> => {
        const payload: ArticuloXListaPrecio = {
            ...articuloXListaPrecio,
            descripcion: normalizeArticuloXListaPrecioDescripcion(articuloXListaPrecio.descripcion),
        };
        const response = await api.post<ArticuloXListaPrecio>('/api/articuloxlistaprecios', payload);
        return response.data;
    },

    updateArticuloXListaPrecio: async (codigoLista: string, codigoArticulo: string, articuloXListaPrecio: ArticuloXListaPrecio): Promise<void> => {
        const payload: ArticuloXListaPrecio = {
            ...articuloXListaPrecio,
            descripcion: normalizeArticuloXListaPrecioDescripcion(articuloXListaPrecio.descripcion),
        };
        await api.put(`/api/articuloxlistaprecios/${codigoLista}/${codigoArticulo}`, payload);
    },

    deleteArticuloXListaPrecio: async (codigoLista: string, codigoArticulo: string): Promise<void> => {
        await api.delete(`/api/articuloxlistaprecios/${codigoLista}/${codigoArticulo}`);
    }
};

export default articuloXListaPrecioService; 